import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import Link from "next/link";
import { ComponentProps } from "react";

export const ContentTags = ({
    tags,
    color,
    className,
    ...props
}: {
    tags: Mix_ContentFragment["mix_content_tags"];
    color?: ComponentProps<typeof Text>["color"];
    className?: string;
}) => {
    return (
        <div
            className={cn("flex items-center overflow-hidden", className)}
            {...props}
        >
            {tags.map((tag, index) => (
                <span
                    key={tag.mix_content_tag_enum.value}
                    className="inline-flex items-center"
                >
                    <Link
                        href={`/?tag=${tag.mix_content_tag_enum.value}`}
                        onClick={(e) => e.stopPropagation()}
                        className="group/tag inline-block rounded-md px-2 py-1
                            transition-all duration-200 ease-out
                            hover:bg-gray-200 dark:hover:bg-gray-700"
                    >
                        <Text
                            variant="body4"
                            color={color || "primary.dark"}
                            className="transition-all duration-200 ease-out
                                group-hover/tag:font-bold"
                        >
                            {tag.mix_content_tag_enum.comment}
                        </Text>
                    </Link>
                    {index < tags.length - 1 && (
                        <Text
                            variant="body4"
                            color={color || "primary.dark"}
                            className="mx-1"
                        >
                            ·
                        </Text>
                    )}
                </span>
            ))}
        </div>
    );
};
